<template>
  <ADSCardSection
    :isAccordion="true"
    :isLoading="false"
    sectionId="testID"
  >
    <template #header>
      Recovery Details EMR Preview
    </template>
    <template #body>
      <div class="sections">
        <div class="row">
          <div class="col-2">
            <ADSTextInput
              id="disabled-text"
              v-model="organSpecification"
              disabled
              label="Organ Specification"
            />
          </div>
          <div class="col-2">
            <ADSTextInput
              id="disabled-text"
              v-model="surgeonOne"
              disabled
              label="Surgeon One"
            />
          </div>
          <div class="col-2">
            <ADSTextInput
              id="disabled-text"
              v-model="recoveryStartDate"
              disabled
              label="Recovery Start Date"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-2">
            <ADSTextInput
              id="disabled-text"
              v-model="recoveryStartTime"
              disabled
              label="Recovery Start Time"
            />
          </div>
          <div class="col-2">
            <ADSTextInput
              id="disabled-text"
              v-model="recoveryEndDate"
              disabled
              label="Recovery End Date"
            />
          </div>
          <div class="col-2">
            <ADSTextInput
              id="disabled-text"
              v-model="recoveryEndTime"
              disabled
              label="Recovery End Time"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-2">
            <ADSTextInput
              id="disabled-text"
              v-model="crossClampDate"
              disabled
              label="Cross Clamp Date"
            />
          </div>
          <div class="col-2">
            <ADSTextInput
              id="disabled-text"
              v-model="crossClampTime"
              disabled
              label="Cross Clamp Time"
            />
          </div>
          <div class="col-2">
            <ADSTextInput
              id="disabled-text"
              v-model="flushDate"
              disabled
              label="Flush Date"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-2">
            <ADSTextInput
              id="disabled-text"
              v-model="flushTime"
              disabled
              label="Flush Time"
            />
          </div>
          <div class="col-2">
            <ADSTextInput
              id="disabled-text"
              v-model="completed"
              disabled
              label="Completed"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-2">
            <ADSTextInput
              id="disabled-text"
              v-model="organShipped"
              disabled
              label="Organ Shipped"
            />
          </div>
          <div class="col-2" v-if="organShipped?.toLowerCase() !== 'no'">
            <ADSTextInput
              id="disabled-text"
              v-model="shippedOutOfProvince"
              disabled
              label="Shipped OOP"
            />
          </div>
          <div class="col-2"  v-if="shippedOutOfProvince === 'Yes'">
            <ADSTextInput
              id="disabled-text"
              v-model="successfullyTransplanted"
              disabled
              label="Successfully Transplanted"
            />
          </div>
          <!-- <div class="col-2" v-if="organ === 'Liver'">
            <ADSTextInput
              id="disabled-text"
              v-model="perfusionPump"
              disabled
              label="Perfusion Pump"
            />
          </div> -->
        </div>
        <div class="row" v-if="organ === 'Liver'">
          <!-- <div class="col-2" v-if="organ === 'Liver'">
            <ADSTextInput
              id="disabled-text"
              v-model="perfusionDate"
              disabled
              label="Perfusion Date"
            />
          </div>  -->
          <div class="col-2" >
            <ADSTextInput
              id="disabled-text"
              v-model="liverGraftWeight"
              disabled
              label="Liver Graft Weight"
            />
          </div>
          <div class="col-2">
            <ADSTextInput
              id="disabled-text"
              v-model="liverAbnormalitiesConcerns"
              disabled
              label="Liver Abnormalities Concerns"
            />
          </div>
        </div>
      </div>
    </template>
  </ADSCardSection>
</template>

<script>
import _ from 'lodash';

export default {
  name: "RecoveryDetailsSection",
  props: {
    patient: {
      type: Object,
      default: null,
    },
    patientBundle: {
      type: Object,
      default: null,
    },
    organ: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      organSpecification: this.getOrganSpecification( this.patientBundle ),
      surgeonOne: this.getSurgeonOne( this.patientBundle ),
      recoveryStartDate: this.getRecoveryStartDate( this.patientBundle )?.substring( 0,10 ),
      recoveryStartTime: this.getRecoveryStartTime( this.patientBundle )?.substring( 0,5 ),
      recoveryEndTime: this.getRecoveryEndTime( this.patientBundle )?.substring( 0,5 ),
      recoveryEndDate: this.getRecoveryEndDate( this.patientBundle )?.substring( 0,10 ),
      crossClampDate: this.getCrossClampDate( this.patientBundle )?.substring( 0,10 ), 
      crossClampTime: this.getCrossClampTime( this.patientBundle )?.substring( 0,5 ),
      flushDate: this.getFlushDate( this.patientBundle )?.substring( 0,10 ),
      flushTime: this.getFlushTime( this.patientBundle )?.substring( 0,5 ),
      comments: this.getComments( this.patientBundle ),
      completed: this.getCompleted( this.patientBundle ),
      organShipped: this.getOrganShipped( this.patientBundle ),
      shippedOutOfProvince: this.getShippedOutOfProvince( this.patientBundle ),
      perfusionPump: this.getPerfusionPump( this.patientBundle ),
      perfusionDate: this.getPerfusionDate( this.patientBundle ),
      successfullyTransplanted: this.getOrganSuccessfullyTransplanted( this.patientBundle ),
      liverGraftWeight: this.getLiverGraftWeight( this.patientBundle, this.organ ),
      liverAbnormalitiesConcerns: this.getLiverAbnormalitiesConcerns( this.patientBundle ),
    };
    },
   mounted() {
    
    },
  methods: {
    combineProps() {
      return `${this.patient}`;
    },
    getOrganSpecification( patientBundle ) {
      let observation = patientBundle.entries.filter( ( n ) => ( _.get( n[0], 'resource.resourceType' ) === 'Observation' &&
        _.get( n[0], 'resource.category[0].coding[0].code' ) === 'smartdata' ) );
      if( observation && observation[ 0 ] ) {
        let organSpecification = observation[ 0 ].filter( ( n ) => ( _.get( n, 'resource.code.coding[0].code' ) === 'UHN#4148' || 
        ( _.get( n, 'resource.code.coding[0].code' ) === 'UHN#4149' ) ) ) ;
      if( organSpecification && organSpecification[ 0 ] ) {
        return _.get( organSpecification[0], 'resource.component[0].valueString' );
      } 
      }
    },
    getSurgeonOne( patientBundle ) {
      let observation = patientBundle.entries.filter( ( n ) => ( _.get( n[0], 'resource.resourceType' ) === 'Observation' &&
        _.get( n[0], 'resource.category[0].coding[0].code' ) === 'smartdata' ) );
      if( observation && observation[ 0 ] ) {
        let surgeonOne = observation[ 0 ].filter( ( n ) => ( _.get( n, 'resource.code.coding[0].code' ) === 'UHN#4073' ) ) ;
      if( surgeonOne && surgeonOne[ 0 ] ) {
        return _.get( surgeonOne[0], 'resource.component[0].valueString' );
      } 
      }
    },
    getRecoveryStartDate( patientBundle ) {
      let observation = patientBundle.entries.filter( ( n ) => ( _.get( n[0], 'resource.resourceType' ) === 'Observation' &&
        _.get( n[0], 'resource.category[0].coding[0].code' ) === 'smartdata' ) );
      if( observation && observation[ 0 ] ) {
        let recoveryStartDate = observation[ 0 ].filter( ( n ) => ( _.get( n, 'resource.code.coding[0].code' ) === 'UHN#4074' ) ) ;
      if( recoveryStartDate && recoveryStartDate[ 0 ] ) {
        return _.get( recoveryStartDate[ 0 ], 'resource.component[0].valueDateTime' ); 
      } 
      }
    },
    getRecoveryStartTime( patientBundle ) {
      let observation = patientBundle.entries.filter( ( n ) => ( _.get( n[0], 'resource.resourceType' ) === 'Observation' &&
        _.get( n[0], 'resource.category[0].coding[0].code' ) === 'smartdata' ) );
      if( observation && observation[ 0 ] ) {
        let recoveryStartDate = observation[ 0 ].filter( ( n ) => ( _.get( n, 'resource.code.coding[0].code' ) === 'UHN#4075' ) ) ;
      if( recoveryStartDate && recoveryStartDate[ 0 ] ) {
        return _.get( recoveryStartDate[ 0 ], 'resource.component[0].valueTime' ); 
      } 
      }
    },
    getRecoveryEndDate( patientBundle ) {
      let observation = patientBundle.entries.filter( ( n ) => ( _.get( n[0], 'resource.resourceType' ) === 'Observation' &&
        _.get( n[0], 'resource.category[0].coding[0].code' ) === 'smartdata' ) );
      if( observation && observation[ 0 ] ) {
        let recoveryEndDate = observation[ 0 ].filter( ( n ) => ( _.get( n, 'resource.code.coding[0].code' ) === 'UHN#4076' ) ) ;
      if( recoveryEndDate && recoveryEndDate[ 0 ] ) {
        return _.get( recoveryEndDate[ 0 ], 'resource.component[0].valueDateTime' ); 
      } 
      }
    },
    getRecoveryEndTime( patientBundle ) {
      let observation = patientBundle.entries.filter( ( n ) => ( _.get( n[0], 'resource.resourceType' ) === 'Observation' &&
        _.get( n[0], 'resource.category[0].coding[0].code' ) === 'smartdata' ) );
      if( observation && observation[ 0 ] ) {
        let recoveryEndDate = observation[ 0 ].filter( ( n ) => ( _.get( n, 'resource.code.coding[0].code' ) === 'UHN#4077' ) ) ;
      if( recoveryEndDate && recoveryEndDate[ 0 ] ) {
        return _.get( recoveryEndDate[ 0 ], 'resource.component[0].valueTime' ); 
      } 
      }
    },
    getCrossClampDate( patientBundle ) {
      let observation = patientBundle.entries.filter( ( n ) => ( _.get( n[0], 'resource.resourceType' ) === 'Observation' &&
        _.get( n[0], 'resource.category[0].coding[0].code' ) === 'smartdata' ) );
      if( observation && observation[ 0 ] ) {
        let crossClampDate= observation[ 0 ].filter( ( n ) => ( _.get( n, 'resource.code.coding[0].code' ) === 'UHN#4061' ) ) ;
      if( crossClampDate && crossClampDate[ 0 ] ) {
        return _.get( crossClampDate[ 0 ], 'resource.component[0].valueDateTime' ); 
      } 
      }
    },
    getCrossClampTime( patientBundle ) {
      let observation = patientBundle.entries.filter( ( n ) => ( _.get( n[0], 'resource.resourceType' ) === 'Observation' &&
        _.get( n[0], 'resource.category[0].coding[0].code' ) === 'smartdata' ) );
      if( observation && observation[ 0 ] ) {
        let crossClampDate= observation[ 0 ].filter( ( n ) => ( _.get( n, 'resource.code.coding[0].code' ) === 'UHN#4062' ) ) ;
      if( crossClampDate && crossClampDate[ 0 ] ) {
        return _.get( crossClampDate[ 0 ], 'resource.component[0].valueTime' ); 
      } 
      }
    },
    getFlushDate( patientBundle ) {
      let observation = patientBundle.entries.filter( ( n ) => ( _.get( n[0], 'resource.resourceType' ) === 'Observation' &&
        _.get( n[0], 'resource.category[0].coding[0].code' ) === 'smartdata' ) );
      if( observation && observation[ 0 ] ) {
        let flushDate = observation[ 0 ].filter( ( n ) => ( _.get( n, 'resource.code.coding[0].code' ) === 'UHN#4063' ) ) ;
      if( flushDate && flushDate[ 0 ] ) {
        return _.get( flushDate[ 0 ], 'resource.component[0].valueDateTime' ); 
      } 
      }
    },
    getFlushTime( patientBundle ) {
      let observation = patientBundle.entries.filter( ( n ) => ( _.get( n[0], 'resource.resourceType' ) === 'Observation' &&
        _.get( n[0], 'resource.category[0].coding[0].code' ) === 'smartdata' ) );
      if( observation && observation[ 0 ] ) {
        let flushDate = observation[ 0 ].filter( ( n ) => ( _.get( n, 'resource.code.coding[0].code' ) === 'UHN#4064' ) ) ;
      if( flushDate && flushDate[ 0 ] ) {
        return _.get( flushDate[ 0 ], 'resource.component[0].valueTime' ); 
      } 
      }
    },
    getComments( patientBundle ) {
      let observation = patientBundle.entries.filter( ( n ) => ( _.get( n[0], 'resource.resourceType' ) === 'Observation' &&
        _.get( n[0], 'resource.category[0].coding[0].code' ) === 'smartdata' ) );
      if( observation && observation[ 0 ] ) {
        let flushDate = observation[ 0 ].filter( ( n ) => ( _.get( n, 'resource.code.coding[0].code' ) === 'TXP#16539' ) ) ;
      if( flushDate && flushDate[ 0 ] ) {
        return _.get( flushDate[ 0 ], 'resource.component[0].valueString' ); 
      } 
      }
    },
    getCompleted( patientBundle ) {
      let observation = patientBundle.entries.filter( ( n ) => ( _.get( n[0], 'resource.resourceType' ) === 'Observation' &&
        _.get( n[0], 'resource.category[0].coding[0].code' ) === 'smartdata' ) );
      if( observation && observation[ 0 ] ) {
        let flushDate = observation[ 0 ].filter( ( n ) => ( _.get( n, 'resource.code.coding[0].code' ) === 'UHN#3816' ) ) ;
      if( flushDate && flushDate[ 0 ] ) {
        return _.get( flushDate[ 0 ], 'resource.component[0].valueBoolean' ) ? 'Yes' : 'No';
      } 
      }
    },
    getOrganShipped( patientBundle ) {
      let observation = patientBundle.entries.filter( ( n ) => ( _.get( n[0], 'resource.resourceType' ) === 'Observation' &&
        _.get( n[0], 'resource.category[0].coding[0].code' ) === 'smartdata' ) );
      if( observation && observation[ 0 ] ) {
        let flushDate = observation[ 0 ].filter( ( n ) => ( _.get( n, 'resource.code.coding[0].code' ) === 'UHN#3825' ) ) ;
      if( flushDate && flushDate[ 0 ] ) {
        return _.get( flushDate[ 0 ], 'resource.component[0].valueBoolean' ) ? 'Yes' : 'No';
      } 
      }
    },
    getShippedOutOfProvince( patientBundle ) {
      let observation = patientBundle.entries.filter( ( n ) => ( _.get( n[0], 'resource.resourceType' ) === 'Observation' &&
        _.get( n[0], 'resource.category[0].coding[0].code' ) === 'smartdata' ) );
      if( observation && observation[ 0 ] ) {
        let flushDate = observation[ 0 ].filter( ( n ) => ( _.get( n, 'resource.code.coding[0].code' ) === 'UHN#3833' ) ) ;
      if( flushDate && flushDate[ 0 ] ) {
        return _.get( flushDate[ 0 ], 'resource.component[0].valueBoolean' ) ? 'Yes' : 'No';
      } 
      }
    },
    getPerfusionPump( patientBundle ) {
      let observation = patientBundle.entries.filter( ( n ) => ( _.get( n[0], 'resource.resourceType' ) === 'Observation' &&
        _.get( n[0], 'resource.category[0].coding[0].code' ) === 'smartdata' ) );
      if( observation && observation[ 0 ] ) {
        let flushDate = observation[ 0 ].filter( ( n ) => ( _.get( n, 'resource.code.coding[0].code' ) === 'TXP#16571' ) ) ;
      if( flushDate && flushDate[ 0 ] ) {
        return _.get( flushDate[ 0 ], 'resource.component[0].valueBoolean' ) ? 'Yes' : 'No';
      } 
      }
    },
    getPerfusionDate( patientBundle ) {
      let observation = patientBundle.entries.filter( ( n ) => ( _.get( n[0], 'resource.resourceType' ) === 'Observation' &&
        _.get( n[0], 'resource.category[0].coding[0].code' ) === 'smartdata' ) );
      if( observation && observation[ 0 ] ) {
        let flushDate = observation[ 0 ].filter( ( n ) => ( _.get( n, 'resource.code.coding[0].code' ) === 'UHN#4059' ) ) ;
      if( flushDate && flushDate[ 0 ] ) {
        return _.get( flushDate[ 0 ], 'resource.component[0].valueDateTime' )?.substring( 0,10 );
      } 
      }
    },
    getOrganSuccessfullyTransplanted( patientBundle ) {
      let observation = patientBundle.entries.filter( ( n ) => ( _.get( n[0], 'resource.resourceType' ) === 'Observation' &&
        _.get( n[0], 'resource.category[0].coding[0].code' ) === 'smartdata' ) );
      if( observation && observation[ 0 ] ) {
        let flushDate = observation[ 0 ].filter( ( n ) => ( _.get( n, 'resource.code.coding[0].code' ) === 'UHN#3994' ) ) ;
      if( flushDate && flushDate[ 0 ] ) {
        return _.get( flushDate[ 0 ], 'resource.component[0].valueBoolean' ) ? 'Yes' : 'No';
      } 
      }
    },
    getLiverGraftWeight( patientBundle ) {
      let observation = patientBundle.entries.filter( ( n ) => ( _.get( n[0], 'resource.resourceType' ) === 'Observation' &&
        _.get( n[0], 'resource.category[0].coding[0].code' ) === 'smartdata' ) );
      if( observation && observation[ 0 ] ) {
        let flushDate = observation[ 0 ].filter( ( n ) => ( _.get( n, 'resource.code.coding[0].code' ) === 'UHN#4078' ) ) ;
      if( flushDate && flushDate[ 0 ] ) {
        return _.get( flushDate[ 0 ], 'resource.component[0].valueString' ); 
      } 
      }
    },
    getLiverAbnormalitiesConcerns( patientBundle ) {
      let observation = patientBundle.entries.filter( ( n ) => ( _.get( n[0], 'resource.resourceType' ) === 'Observation' &&
        _.get( n[0], 'resource.category[0].coding[0].code' ) === 'smartdata' ) );
      if( observation && observation[ 0 ] ) {
        let flushDate = observation[ 0 ].filter( ( n ) => ( _.get( n, 'resource.code.coding[0].code' ) === 'UHN#4079' ) ) ;
      if( flushDate && flushDate[ 0 ] ) {
        return _.get( flushDate[ 0 ], 'resource.component[0].valueString' ); 
      } 
      }
    },
  },
};
</script>

<style scoped>

/* .card {
  height: 340px;
} */

.sectionHeading {
  background-color: rgb(59, 53, 53);
  color: white;
  padding-left: 5px;
}
.page-content .summary-card .card-header .summary-name {
  padding-left: 35px;
  padding-top: 4px;
  font-weight: 300;
}

.sections {
  font-size: 15px;
  height: 700px;
  width: 1400px;
  /* overflow: scroll; */
  padding-left: 10px;
  /* padding-top: 5px; */
}

.inputDisplay {
border-style: solid;
background-color: #F2F2F2;
}

.fieldName {
  font-weight: 700;
  font-size: 0.875rem;
  padding-top: 5.5px;
  padding-bottom: 2.5px;
}

:deep(.afflo-ds-form-control) {
  width: max-content;
}

:deep(label) {
  width: max-content;
}

:deep(.ExceptionalDistributionReasonOther .afflo-ds-form-control) {
  width: 400px;
}

</style>
